// generated from 3_455 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const invalidNumberFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("invalid_number_filter"),
  comparison_key: z.literal("1"),
  display_name: z.string(),
  // undefined: 2_855 (82.63%), defined 600 (17.37%)
  // true 53 (8.83%), false 547 (91.17%)
  raw_value: z.boolean().optional(),
  // true 175 (5.07%), false 3_280 (94.93%)
  value: z.boolean(),
  varies_by_app_group: z.literal(false),
});
